import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getDefaultWalletProvider = async () => {
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.DEFAULT_WALLET_PROVIDER}`
  );

  return data;
};

export default function useDefaultWalletProvider() {
  return useQuery("getDefaultWalletProvider", getDefaultWalletProvider);
}
